export default __webpack_public_path__ + "static/media/routerlogo.0a8420ef.png";